import React from 'react'

export const DetailCategory = () => {
  return (
    <div>Detail</div>
  )
}
